import styled from 'styled-components';

export const GrayBackground = styled.div`
  background-color: var(--color-surface-muted);
  width: 100%;
`;
